"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteRapidosMutation = exports.useRapidosByIdQuery = exports.useGetRapidosQuery = exports.useAddOrUpdateRapidosMutation = exports.RapidosApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
const Utils_1 = require("../../Utils");
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.RapidosApi = (0, react_1.createApi)({
    reducerPath: "rapidosApi",
    tagTypes: ["rapidos", "rapidosList", "rapidosById"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    endpoints: (builder) => ({
        addOrUpdateRapidos: builder.mutation({
            invalidatesTags: ["rapidos", "rapidosList", "rapidosById"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `rapidos/${id}/`,
                        method: "POST",
                        body: data,
                    };
                }
                return {
                    url: `rapidos/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        getRapidos: builder.query({
            providesTags: ["rapidosList"],
            query: (query) => (0, Utils_1.QueryUrl)("rapidos", query),
        }),
        rapidosById: builder.query({
            query: (id) => `rapidos/${id}/`,
            providesTags: ["rapidosById"],
        }),
        deleteRapidos: builder.mutation({
            query: (id) => ({
                url: `rapidos/${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["rapidos", "rapidosList", "rapidosById"],
        }),
    }),
});
exports.useAddOrUpdateRapidosMutation = exports.RapidosApi.useAddOrUpdateRapidosMutation, exports.useGetRapidosQuery = exports.RapidosApi.useGetRapidosQuery, exports.useRapidosByIdQuery = exports.RapidosApi.useRapidosByIdQuery, exports.useDeleteRapidosMutation = exports.RapidosApi.useDeleteRapidosMutation;
